export default "__VITE_ASSET__05vm6nwB__"